import { useQuery } from '@tanstack/react-query';
import useAuthContext from 'src/context/AuthProvider/useAuthContext';
import GetIdVerificationStatusUseCase from 'src/features/verification/domain/useCases/GetIdVerificationStatusUseCase';
import { diContainer } from 'src/inversify.config';

const getIdVerificationStatusUseCase = diContainer.get(
  GetIdVerificationStatusUseCase
);

export default function useIdVerificationStatus() {
  const { session } = useAuthContext();

  const accessToken = session?.accessToken;

  const query = useQuery({
    queryKey: ['idVerification', 'status', accessToken],
    queryFn: () =>
      getIdVerificationStatusUseCase.execute({ token: accessToken! }),
  });

  return query;
}
